(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  
  
  
  
  
  const dropdownMenuLink = document.querySelector('#dropdownMenuLink');
console.log(dropdownMenuLink.id, document.querySelector(`[aria-labelledby="${dropdownMenuLink.id}"]`))
  if(dropdownMenuLink) {
    let activeEl = document.querySelector(`[aria-labelledby="${dropdownMenuLink.id}"]`);

    if(activeEl) {
      dropdownMenuLink.addEventListener('click', (ev) => {
        ev.preventDefault();
        activeEl.classList.toggle('show');
      })
    }
  }
  






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery === 'undefined' || typeof jQuery('.mt-slider').slick !== 'function') {
      console.warn('⚠️ Slick library not loaded');
      return;
    }

    jQuery('.mt-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"]) return;
  try {
    
    $('.inner_lash_like').slick({
      dots: false,
    infinite: false,
      arrows: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          infinite: false,
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();
})();
